import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';
import { AlertModel } from 'app/modules/settings/interfaces/notification';
import { LoanDetailsListOfLoansService } from '../../loan-details-modal/loan-details-list-of-loans.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-notifications',
    templateUrl: './dialog-notifications.component.html',
    styleUrls: ['./dialog-notifications.component.scss'],
})
export class DialogNotificationsComponent implements OnInit {
    dialogNotifications: AlertModel[];
    navLink: string = 'loanDetails/';
    AlertValueTypes = [
        '%LOAN_NUMBER',
        '%HIERARCHY_IDENTIFIER',
        '%PRODUCT_TYPE',
        '%GL_ACCOUNT_NUMBER',
    ];
    dayInMinutes = 1440;
    hourInMinutes = 60;
    minInMillisecs = 60000;
    max = 25;
    currTime: number;
    constructor(
        public notificationDialogRef: MatDialogRef<DialogNotificationsComponent>,
        private _notificationService: NotificationService,
        private listOfLoansService: LoanDetailsListOfLoansService,
        private router: Router
    ) {
        this.currTime = new Date().getTime();
    }

    ngOnInit() {
        this.getNotifications();
    }

    getNotifications() {
        this._notificationService.getNotifications().subscribe(
            (data) => {
                if (data) {
                    let recentTen = data
                        .filter((alert: AlertModel) => alert.isRead === false)
                        .sort((a: AlertModel, b: AlertModel) =>
                            a.alertDate > b.alertDate ? -1 : a.alertDate < b.alertDate ? 1 : 0
                        )
                        .slice(0, 10);
                    this.dialogNotifications = this.formatAlerts(recentTen);
                }
            },
            (error) => {
                throw new Error(error);
            }
        );
    }

    formatAlerts(notifications: AlertModel[]): AlertModel[] {
        for (let notification of notifications) {
            if (notification && notification.alertName) {
                notification.alertDescription = this.insertAlertValue(notification);
                this.setAlertTime(notification);
            }
        }

        return notifications;
    }

    setAlertTime(notification: AlertModel) {
        notification.dateOffset =
            (this.currTime - new Date(notification.alertDate).getTime()) / this.minInMillisecs;
        notification.offsetType = 'minute';
        if (notification.dateOffset >= this.dayInMinutes) {
            notification.dateOffset /= this.dayInMinutes;
            notification.offsetType = 'day';
        } else if (notification.dateOffset >= this.hourInMinutes) {
            notification.dateOffset /= this.hourInMinutes;
            notification.offsetType = 'hour';
        }
        if (notification.dateOffset >= 2) notification.offsetType += 's';
    }

    insertAlertValue(notification: AlertModel): string {
        this.AlertValueTypes.forEach((el) => {
            if (notification.alertDescription.includes(el))
                notification.alertDescription = notification.alertDescription.replace(
                    el,
                    notification.alertValue ? notification.alertValue : ''
                );
        });
        return notification.alertDescription;
    }

    alertClickHandler(notification: AlertModel) {
        if (notification.alertValue !== null && notification.alertType !== null) {
            this.notificationDialogRef.close();
            notification.isRead = true;
            this.updateAlertStatus(notification);
            switch (notification.alertType.toLowerCase()) {
                case 'loannumber':
                    this.openLoanModal(notification.alertValue);
                    break;
                case 'hirereachy identier':
                    this.router.navigate([`/directory/record/${notification.alertValue}`]);
                    break;
                case 'product':
                    this.router.navigate(['/settings/client-product-mapping']);
                    break;
                default:
                    this.router.navigate(['/settings/notifications']);
                    break;
            }
        }
    }

    updateAlertStatus(alert: AlertModel): void {
        this._notificationService.updateAlert(alert).subscribe(
            () => {},
            (error) => {
                throw new Error(error);
            }
        );
    }

    openLoanModal(identifier: string) {
        let loanNumber = identifier.split(' ').pop();
        let index = 0;
        this.listOfLoansService.changeListOfLoans({
            loanNumbers: [loanNumber],
            index: index,
        });
        this.router.navigate([{ outlets: { modal: 'loanDetails' + '/' + loanNumber } }]);
    }

    selectionChangeHandler(event: any): void {}

    onNoClick(): void {
        this.notificationDialogRef.close();
    }
}
